const de = {
  languageName: "Deutsch",
  guestFallback: "Gast",
  genericError: "Das hat leider nicht geklappt. Bitte versuchen Sie es erneut.",
  checkMarkedFields: "Bitte prüfen Sie die markierten Felder.",
  imageReadError: "Das ausgewählte Bild konnte vom Browser nicht gelesen werden.",
  imageConvertError: "Das ausgewählte Bild konnte nicht in JPEG umgewandelt werden.",
  unsupportedImageFormat: "Bitte laden Sie ein JPEG-, PNG- oder WebP-Bild hoch.",
  reservationNotFound: "Reservierung nicht gefunden.",
  ownerOnly: "Dieser Check-in Link ist nur für den Buchungsinhaber verfügbar.",
  required: "{field} ist erforderlich.",
  progress: "Fortschritt",
  loading: "Check-in wird vorbereitet...",
  selectPlaceholder: "Bitte wählen",
  back: "Zurück",
  continue: "Weiter",
  saving: "Speichern...",
  startCheckin: "Check-in starten",
  uploadId: "Ausweis hochladen",
  confirmData: "Daten bestätigen",
  complete: "Registrierung abschließen",
  checking: "Prüfen...",
  dismissError: "Fehlermeldung schließen",
  checkin: "CHECK-IN",
  wordmark: "GUEST JOURNEY",
  language: "Sprache",
  overview: {
    kicker: "Online Check-in",
    title: "IHRE RESERVIERUNG",
    reservation: "Reservierung",
    guest: "Gast",
    room: "Zimmer",
    stay: "Aufenthalt",
    returningQuestion: "Sind Sie {name}?",
    yes: "Ja, das bin ich",
    no: "Nein",
  },
  details: { title: "GASTDATEN" },
  purpose: { title: "IHR AUFENTHALT", question: "Ist dieser Aufenthalt privat oder geschäftlich?", private: "Privat", business: "Geschäftlich" },
  idIntro: {
    title: "ID-VERIFIZIERUNG",
    copy: "Scannen Sie ein gültiges Ausweisdokument oder laden Sie es hoch. Sie können die Daten danach prüfen und bei Bedarf manuell ergänzen.",
    copyIntro: "Scannen Sie ein gültiges Ausweisdokument oder laden Sie es hoch (",
    copyOutro: "). Sie können die Daten danach prüfen und bei Bedarf manuell ergänzen.",
    expressScan: "EXPRESS SCAN",
  },
  documents: {
    idCard: "Personalausweis",
    passport: "Reisepass",
    driverLicense: "Führerschein",
  },
  camera: {
    help: "Hilfe",
    ready: "Rückseite des Ausweises wird gesucht...",
    requesting: "Kamera wird gestartet...",
    denied: "Kamera nicht verfügbar. Bitte laden Sie Ihr Dokument hoch.",
    unavailable: "Ihr Browser unterstützt keine Kameraaufnahme.",
    helpText: "Halten Sie das Dokument flach, hell und vollständig im Rahmen.",
  },
  identity: {
    title: "ID-VERIFIZIERUNG",
  },
  address: {
    title: "ANSCHRIFT",
  },
  review: {
    title: "ABSCHLIESSEN",
    document: "Dokument",
    address: "Adresse",
    travelPurpose: "Reiseanlass",
    terms: "Ich akzeptiere die AGB.",
    privacy: "Ich habe die Datenschutzhinweise gelesen.",
    contactPermission: "Ich möchte relevante Informationen zum Aufenthalt erhalten.",
    backendError: "Bitte prüfen Sie die Angaben. Einige Pflichtfelder fehlen oder wurden vom Backend nicht akzeptiert.",
    nextGuest: "Weiter zum nächsten Gast",
    continueServices: "Weiter zu den Zusatzleistungen",
  },
  services: {
    kicker: "Zusatzleistungen",
    title: "LEISTUNGEN",
    selected: "Inklusive und ausgewählt",
    selectedState: "Ausgewählt",
    included: "Inklusive",
    includedState: "In Ihrer Reservierung enthalten",
    empty: "Für diese Reservierung werden keine Zusatzleistungen angeboten.",
    priceUnavailable: "Preis nicht verfügbar",
    add: "Leistung hinzufügen",
    remove: "Entfernen",
    skipOne: "Überspringen",
    retry: "Leistungen aktualisieren",
    licensePlate: "Kennzeichen",
    licensePlateRequired: "Bitte geben Sie Ihr Kennzeichen für den Parkplatz ein.",
    pickupDate: "Abholdatum für das Taxi",
    pickupTime: "Abholzeit für das Taxi",
    pickupHour: "Stunde",
    pickupMinute: "Minute",
    pickupNote: "Hinweis zur Abholung (optional)",
    taxiRequired: "Bitte wählen Sie ein Abholdatum und eine Abholzeit.",
    taxiQuarterHour: "Bitte wählen Sie eine Abholzeit in 15-Minuten-Schritten.",
    summary: "IHRE AUSWAHL",
    inBasket: "In Ihrer Auswahl",
    basketTotal: "Ausgewählte Zusatzleistungen",
    estimatedTotal: "Offener Betrag",
    noneSelected: "Keine zusätzlichen Leistungen ausgewählt.",
    booked: "Bereits gebucht",
    pendingRemoval: "Wird entfernt",
    keep: "Leistung behalten",
    quantity: "Anzahl",
    quantityRequired: "Bitte geben Sie eine verfügbare Anzahl von mindestens 1 ein.",
    breakfastAdults: "Erwachsene",
    breakfastChildren: "Kinder 7–13",
    breakfastFreeChildren: "Kinder 0–6",
    breakfastTotal: "Frühstück gesamt",
    breakfastGuestLimit: "Die Anzahl darf die Gästezahl dieses Zimmers nicht überschreiten.",
    breakfastChildUnavailable: "Kinderfrühstück ist für diese Reservierung oder Anzahl nicht verfügbar.",
    free: "Kostenlos",
    notAvailable: "Nicht verfügbar",
    dates: "Leistungsdaten",
    datesRequired: "Bitte wählen Sie ein verfügbares Leistungsdatum.",
    wholeStay: "Gesamter Aufenthalt",
    sauna: "Sauna",
    saunaNoticeLead: "30 MIN",
    saunaNotice: "Bitte informieren Sie die Rezeption mindestens 30 Minuten vor der gewünschten Saunanutzung.",
    babyBed: "Babybett",
    pet: "Haustier",
    saveFailed: "Die ausgewählten Leistungen konnten nicht gespeichert werden.",
    processing: "Ihr Aufenthalt wird vorbereitet...",
    uncertain: "Das Hotel hat noch nicht bestätigt, ob die letzte Änderung gespeichert wurde. Bitte kontaktieren Sie das Hotel, bevor Sie es erneut versuchen.",
  },
  payment: {
    kicker: "Nach den Leistungen",
    title: "ZAHLUNG",
    balance: "Offener Betrag",
    noneDue: "Keine Zahlung erforderlich",
    charge: "Position",
    unavailable: "Nicht verfügbar",
    due: "Bitte begleichen Sie den offenen Betrag vor dem Check-in.",
    returned: "Kehren Sie nach der Zahlung hierher zurück (oder nutzen Sie Zurück im Browser). Der Zahlungsstatus wird automatisch geprüft.",
    confirmed: "Zahlung vom Hotelsystem bestätigt.",
    testOverride: "Backend-Test-Override ist aktiv. Die Zahlung wird für diesen Test übersprungen.",
    pay: "Offenen Betrag bezahlen",
    checkAgain: "Erneut prüfen",
    verifying: "Ihre Zahlung wird mit dem Hotelsystem abgeglichen...",
    verificationUnavailable: "Die Zahlungsprüfung ist vorübergehend nicht verfügbar. Wir prüfen weiter.",
    verificationStopped: "Die Zahlungsprüfung konnte nicht fortgesetzt werden. Bitte öffnen Sie Ihren Gastlink erneut oder kontaktieren Sie das Hotel.",
    pending: "Die Zahlung wurde noch nicht bestätigt. Bitte prüfen Sie sie nach der Zahlung erneut.",
    pollTimeout: "Die Zahlungsbestätigung dauert länger als erwartet. Prüfen Sie den Betrag erneut.",
    linkUnavailable: "Ein Zahlungslink ist nicht verfügbar. Bitte kontaktieren Sie das Hotel.",
    linkExpired: "Der Zahlungslink ist abgelaufen oder passt nicht mehr zum offenen Betrag. Bitte kontaktieren Sie das Hotel.",
  },
  completion: {
    title: "Online-Registrierung abgeschlossen!",
    copy: "Ihre Registrierungsdaten wurden übermittelt. Hotel-Check-in und Zimmerzugang werden weiterhin vom Hotelsystem gesteuert.",
    accessPin: "Ihr Zugangscode",
    roomAccessUnavailable: "Zimmerzugang ist noch nicht verfügbar",
    roomAccessUnavailableCopy: "Bitte wenden Sie sich an die Rezeption, wenn Sie Hilfe mit dem Zimmerzugang benötigen.",
    paymentRequired: "Zahlung erforderlich",
    goToCheckout: "Zum Checkout",
    dryRun: "Entwicklungsmodus: Der Check-in wurde als Dry Run validiert.",
    continueToRoomJourney: "Zur Zimmer-App",
    backToBooking: "Zurück zur Buchung",
    roomGuestLinks: "Zimmergast-Links",
    notConfirmed: "Die Registrierung wurde vom Hotelsystem nicht bestätigt. Bitte versuchen Sie es erneut.",
  },
  fields: {
    email: "E-Mail",
    phone: "Telefon",
    travel_purpose: "Aufenthaltsart",
    nationality_country_code: "Nationalität",
    document_type: "Dokumenttyp",
    document_number: "Dokumentnummer",
    document_issued_on: "Ausstellungsdatum",
    date_of_birth: "Geburtsdatum",
    gender: "Geschlecht",
    street_name: "Straße und Hausnummer",
    address_line_2: "Adresszusatz optional",
    zip_code: "Postleitzahl",
    city: "Stadt",
    country_code: "Land",
    company_name: "Firmenname",
    company_vat_number: "USt-IdNr. (optional)",
    terms_accepted: "AGB",
    privacy_accepted: "Datenschutz",
  },
  countries: {
    DE: "Deutschland",
    AT: "Österreich",
    CH: "Schweiz",
    NL: "Niederlande",
    FR: "Frankreich",
    IT: "Italien",
    ES: "Spanien",
    GB: "Vereinigtes Königreich",
    US: "Vereinigte Staaten",
  },
  documentTypes: {
    ID_CARD: "Personalausweis",
    PASSPORT: "Reisepass",
    DRIVER_LICENSE: "Führerschein",
  },
  genders: {
    MALE: "Männlich",
    FEMALE: "Weiblich",
    DIVERSE: "Divers",
  },
  travelPurposes: {
    BUSINESS: "Geschäftlich",
    LEISURE: "Freizeit",
    MIXED: "Kombination aus beidem",
    OTHER: "Sonstiges",
  },
};

export default de;
